import React, {useState, useRef, useEffect} from 'react';
import { useCookies } from 'react-cookie';
import moment from 'moment/moment';
import axios from 'axios';
import { useLocation } from "react-router-dom";
import { 
    Flex, Box, VStack, Heading, Button, ButtonGroup, Text, Icon, IconButton, FormControl, FormLabel, Input,
    Table, Thead, Tbody, Tfoot, Tr, Th, Td, TableCaption, TableContainer, Alert, AlertIcon, AlertDescription, Select,
    Center, CircularProgress, CircularProgressLabel, useToast,
    HStack
} from '@chakra-ui/react';
import { MdSave, MdFileUpload, MdDeleteForever } from 'react-icons/md';
import LeftPanel from './Panels/LeftPanel';
import Dashboard from './Dashboard';
import ChenhLechTien from './ChenhLechTien';
import ImportDatas from './ImportDatas';
import ImportDatasV2 from './ImportDatasV2';
import Admin from './Admin';
import QuanLyDonHang from './QuanLyDonHang';

function Home() {
    const [isLoading, setIsLoading] = useState(false);
    const [ isProcessing, setIsProcessing ] = useState(false);

    const toast = useToast();
    const mounted = useRef();
    const locations = useLocation();
    
    useEffect(() => {
        if(!mounted.current) {
            mounted.current = true;
        }
    }, []);

    return (
        <Box w="100vw" h="100%" bg="ghostwhite">
            <Flex flexDirection={{ base: "column", md: "row", lg: "row" }} justify="flex-start" gap={{ base: 4, md: 4, lg: 4 }}>
                <LeftPanel />
                { locations.pathname === "/" && <Dashboard /> }
                { locations.pathname === "/compare-money" && <ChenhLechTien /> }
                { locations.pathname === "/import-datas" && <ImportDatas /> }
                { locations.pathname === "/import-datas-v2" && <ImportDatasV2 /> }
                { locations.pathname === "/admin" && <Admin /> }
                { locations.pathname === "/order-management" && <QuanLyDonHang /> }
            </Flex>
        </Box>
    )
}

export default Home;